'use client'

import { LineTrashAlt } from '@qr-front/icons/line-trash-alt'
import { Button } from '@qr-front/ui/components/Button'
import { Dialog, DialogContent } from '@qr-front/ui/components/Dialog'
import { useTranslations } from 'next-intl'

type TModalData = {
	isOpen: boolean
	onCancel?: () => void
	onDelete?: () => void
}

export const SectionDeleteModal = ({
	isOpen: isOpenProp,
	onCancel,
	onDelete,
}: TModalData) => {
	const t = useTranslations()

	return (
		<Dialog open={isOpenProp} onOpenChange={onCancel}>
			<DialogContent
				closeButtonLabel={t('ui__popup__close_button')}
				className="w-[350px] p-0 tablet:w-[400px]"
			>
				<div className="flex flex-col gap-4 p-6 tablet:p-8">
					<div className="flex items-center gap-2 self-center rounded-full bg-light-grey-80 p-8">
						<LineTrashAlt className="text-blue" width={32} height={32} />
					</div>
					<div className="flex flex-col gap-6">
						<div className="flex flex-col items-center gap-2">
							<h3 className="type-heading-3">
								{t(
									'generator__content_form_section__menu__sections__delete_modal_title',
								)}
							</h3>
							<p className="text-grey-60 type-body-medium text-center text-dark-grey">
								{t(
									'generator__content_form_section__menu__sections__delete_modal_description',
								)}
							</p>
						</div>
						<div className="flex w-full justify-between gap-4 tablet:gap-6">
							<Button
								visual="secondary"
								size="large"
								className="flex-1"
								onClick={onCancel}
							>
								{t(
									'generator__content_form_section__menu__sections__modal__cancel_button',
								)}
							</Button>
							<Button size="large" className="flex-1" onClick={onDelete}>
								{t(
									'generator__content_form_section__menu__sections__modal__delete_button',
								)}
							</Button>
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
